import { z } from "zod";
import {
  membershipStatusSchema,
  organizationRoleSchema,
  platformRoleSchema,
} from "../enums.js";
import { isoDate, optionalIsoDate } from "./common.js";

export const platformUserMembershipSchema = z.object({
  membershipId: z.string(),
  organizationId: z.string(),
  organizationName: z.string(),
  role: organizationRoleSchema,
  status: membershipStatusSchema,
});
export type PlatformUserMembership = z.infer<typeof platformUserMembershipSchema>;

export const platformUserSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  fullName: z.string().nullable(),
  platformRole: platformRoleSchema,
  createdAt: isoDate,
  lastLoginAt: optionalIsoDate,
  memberships: z.array(platformUserMembershipSchema),
});
export type PlatformUser = z.infer<typeof platformUserSchema>;

/** An invited email with no linked User row yet — activates on first login. */
export const pendingInviteSchema = z.object({
  membershipId: z.string(),
  email: z.string().email(),
  organizationId: z.string(),
  organizationName: z.string(),
  role: organizationRoleSchema,
  invitedByEmail: z.string().email().nullable(),
  createdAt: isoDate,
});
export type PendingInvite = z.infer<typeof pendingInviteSchema>;

export const listPlatformUsersQuerySchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(25),
  search: z.string().max(200).optional(),
  platformRole: platformRoleSchema.optional(),
  organizationId: z.string().optional(),
});
export type ListPlatformUsersQuery = z.input<typeof listPlatformUsersQuerySchema>;

export const platformUserListPageSchema = z.object({
  items: z.array(platformUserSchema),
  nextCursor: z.string().nullable(),
  pendingInvites: z.array(pendingInviteSchema),
});
export type PlatformUserListPage = z.infer<typeof platformUserListPageSchema>;

export const updatePlatformRoleSchema = z.object({
  platformRole: platformRoleSchema,
});
export type UpdatePlatformRoleInput = z.infer<typeof updatePlatformRoleSchema>;

export const adminAssignMembershipSchema = z.object({
  organizationId: z.string(),
  email: z.string().email(),
  role: organizationRoleSchema,
});
export type AdminAssignMembershipInput = z.infer<typeof adminAssignMembershipSchema>;

export const adminUpdateMembershipSchema = z.object({
  organizationId: z.string(),
  fullName: z.string().trim().max(200).nullable().optional(),
  role: organizationRoleSchema.optional(),
  status: membershipStatusSchema.optional(),
});
export type AdminUpdateMembershipInput = z.infer<typeof adminUpdateMembershipSchema>;
